const doc = [({"en":({"js":({"admin":({"suppliers":({"select":({"choose_supplier":"Choose supplier"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;